import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setCreateJiraTicket } from '../../redux/actions/assetsAction';
import { toggleCreateAssetView } from '../../redux/actions/createAssetViewActions';
import Create from './Create';
// Upload CSV layout view which calls reusable Create component under the hood.
const UploadCSVLayout = () => {
	const dispatch = useDispatch();
	useEffect(() => {
		// setting the state to keep track of Upload CSV view (used in the reusable components) is active.
		dispatch(toggleCreateAssetView(true));
		// set Jira ticket checkbox true on CSV upload view.
		dispatch(setCreateJiraTicket(true));
	}, [dispatch]);
	return <Create></Create>;
};

export default UploadCSVLayout;
